import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, TrophyIcon } from 'lucide-react';
interface VenueWelcomeProps {
  onStart: () => void;
  onViewLeaderboard: () => void;
}
export function VenueWelcome({
  onStart,
  onViewLeaderboard
}: VenueWelcomeProps) {
  return <div className="flex flex-col h-full relative overflow-hidden bg-brand-green-deep" data-id="element-310">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(184,150,90,0.2)_0%,transparent_60%)]" data-id="element-311" />
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+')] opacity-20 mix-blend-overlay" data-id="element-312" />

      <div className="relative z-10 flex-1 flex flex-col p-8" data-id="element-313">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-center mt-8 mb-auto" data-id="element-314">
          <img src="https://cdn.magicpatterns.com/uploads/48pxZfgiUmX71EJYj94JCW/image.png" alt="Fern Resort" className="w-14 h-14 object-contain mx-auto mb-3 rounded-lg bg-white/90 p-1.5" data-id="element-315" />
          <div className="inline-flex items-center justify-center space-x-2 bg-brand-cream/10 px-4 py-1.5 rounded-full backdrop-blur-sm border border-brand-cream/10 mb-6" data-id="element-316">
            <MapPinIcon className="w-4 h-4 text-brand-gold" data-id="element-317" />
            <span className="text-xs font-body text-brand-cream-light uppercase tracking-widest" data-id="element-318">
              Fern Resort, Orillia
            </span>
          </div>
          <h1 className="text-5xl font-heading text-brand-cream-light mb-4 leading-tight" data-id="element-319">
            The Sunset
            <br data-id="element-320" />
            Green
          </h1>
          <p className="text-brand-cream/70 font-body text-sm max-w-[240px] mx-auto" data-id="element-321">
            A premium 9-hole putting experience designed by PuttLab.
          </p>
        </motion.div>

        {/* Actions */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="mt-auto space-y-4" data-id="element-322">
          <button onClick={onStart} className="w-full bg-brand-gold text-brand-charcoal font-heading text-xl py-5 rounded-xl shadow-lg hover:bg-brand-gold-light transition-colors active:scale-[0.98]" data-id="element-323">
            Start Playing
          </button>

          <button onClick={onViewLeaderboard} className="w-full flex items-center justify-center space-x-2 bg-brand-cream-light/5 text-brand-cream-light font-body py-4 rounded-xl border border-brand-cream/10 hover:bg-brand-cream-light/10 transition-colors active:scale-[0.98]" data-id="element-324">
            <TrophyIcon className="w-5 h-5 text-brand-gold" data-id="element-325" />
            <span data-id="element-326">View Leaderboard</span>
          </button>
        </motion.div>
      </div>
    </div>;
}